import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  Home, 
  BookOpen, 
  BarChart3, 
  Settings, 
  HelpCircle, 
  Info, 
  X,
  User,
  LogOut
} from 'lucide-react';

const AppMenu = ({ isOpen, onClose, user, onOpenAuth, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path) => {
    navigate(path);
    onClose();
  };

  const menuItems = [
    {
      icon: Home,
      label: 'მთავარი',
      path: '/',
      description: 'მთავარ გვერდზე დაბრუნება'
    },
    {
      icon: BookOpen,
      label: 'გაკვეთილები',
      path: '/menu',
      description: 'კურსის შიგთავსი და გაკვეთილები'
    },
    {
      icon: BarChart3,
      label: 'პროგრესი',
      path: '/progress',
      description: 'თქვენი მიღწევები და სტატისტიკა'
    },
    {
      icon: Settings,
      label: 'პარამეტრები',
      path: '/settings',
      description: 'აპლიკაციის კონფიგურაცია'
    },
    {
      icon: HelpCircle,
      label: 'დახმარება',
      path: '/help',
      description: 'ხშირად დასმული კითხვები'
    },
    {
      icon: Info,
      label: 'შესახებ',
      path: '/about',
      description: 'კურსის და აპლიკაციის შესახებ'
    }
  ];

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-50"
        onClick={onClose}
      />
      
      {/* Menu Panel */}
      <div className="fixed top-0 left-0 h-full w-80 bg-white shadow-2xl z-50 overflow-hidden">
        {/* Header */}
        <div className="bg-blue-600 text-white p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-bold font-['bpg-caps']">მენიუ</h2>
            <button
              onClick={onClose}
              className="p-1 hover:bg-blue-700 rounded transition-colors"
              aria-label="Close menu"
            >
              <X size={20} />
            </button>
          </div>
          
          {/* User section */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center">
              <User size={18} />
            </div>
            <div className="flex-1">
              {user ? (
                <div>
                  <div className="font-semibold font-['bpg-caps']">{user.name}</div>
                  <div className="text-blue-200 text-sm">{user.email}</div>
                </div>
              ) : (
                <button
                  onClick={() => {
                    onOpenAuth();
                    onClose();
                  }}
                  className="text-left hover:text-blue-200 transition-colors font-['bpg-caps']"
                >
                  შესვლა/რეგისტრაცია
                </button>
              )}
            </div>
            {user && (
              <button
                onClick={() => {
                  onLogout();
                  onClose();
                }}
                className="p-1 hover:bg-blue-700 rounded transition-colors"
                aria-label="Logout"
              >
                <LogOut size={16} />
              </button>
            )}
          </div>
        </div>

        {/* Navigation Items */}
        <nav className="p-4 flex-1">
          <div className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              
              return (
                <button
                  key={item.path}
                  onClick={() => handleNavigation(item.path)}
                  className={`w-full flex items-start gap-3 p-3 rounded-lg transition-colors text-left ${
                    isActive 
                      ? 'bg-blue-50 text-blue-700 border-l-4 border-blue-600' 
                      : 'hover:bg-gray-50 text-gray-700'
                  }`}
                >
                  <Icon size={20} className="flex-shrink-0 mt-0.5" />
                  <div className="flex-1">
                    <div className={`font-semibold font-['bpg-caps'] ${
                      isActive ? 'text-blue-700' : 'text-gray-800'
                    }`}>
                      {item.label}
                    </div>
                    <div className={`text-sm ${
                      isActive ? 'text-blue-600' : 'text-gray-500'
                    }`}>
                      {item.description}
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        </nav>

        {/* Footer */}
        <div className="p-4 border-t border-gray-200">
          <div className="text-xs text-gray-500 text-center">
            აფხაზური ენის კურსი v1.0
          </div>
        </div>
      </div>
    </>
  );
};

export default AppMenu;